import { render, staticRenderFns } from "./reception-explain.vue?vue&type=template&id=2bf8ca87&scoped=true"
import script from "./reception-explain.vue?vue&type=script&lang=js"
export * from "./reception-explain.vue?vue&type=script&lang=js"
import style0 from "./reception-explain.vue?vue&type=style&index=0&id=2bf8ca87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8ca87",
  null
  
)

export default component.exports